export default [
  'fetchTheme',
]


// WEBPACK FOOTER //
// ./src/store/theme/types.js